module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "three-remix"
  }, [_c('wave-scene', {
    staticClass: "frame",
    attrs: {
      "mouseControlEnabled": ""
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay-text"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/mrdoob/three.js/blob/master/examples/webgl_points_waves.html"
    }
  }, [_vm._v("MrDoob")]), _vm._v(" x\n\t\t"), _c('a', {
    attrs: {
      "href": "https://github.com/ianpaschal/three-vue-viewport/blob/master/src/PerspectiveViewport.js"
    }
  }, [_vm._v("IanPaschal")]), _vm._v(" x\n\t\t"), _c('a', {
    attrs: {
      "href": "https://github.com/frantsen/portfolio/tree/master/src/components/ThreeRemix.vue"
    }
  }, [_vm._v("Frantsen")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "overlay-subtext"
  }, [_vm._v("\n\t\t\tutilizing\n\t\t\t"), _c('a', {
    attrs: {
      "href": "https://threejs.org"
    }
  }, [_vm._v("Three.js")]), _vm._v(" +\n\t\t\t"), _c('a', {
    attrs: {
      "href": "https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API"
    }
  }, [_vm._v("WebGL")]), _vm._v(" +\n\t\t\t"), _c('a', {
    attrs: {
      "href": "https://vuejs.org"
    }
  }, [_vm._v("Vue.js")]), _vm._v(" +\n\t\t\t"), _c('a', {
    attrs: {
      "href": "https://vuex.vuejs.org"
    }
  }, [_vm._v("Vuex")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2a03352","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThreeRemix.vue
// module id = 120
// module chunks = 1